import React, { Component } from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import FeedsComponent from '../../components/feeds/containers/FeedsContainer';
import { getNewsCategoryIfNeeded } from '../../components/news/actions/NewsActions';

const headerTags =
{
    title: 'Conheça nossas opções de feed', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta:
    {
        description: 'Fique por dentro de todas as notícias da Antena 1 através de feeds rss, atom ou json',
        keywords: 'feed, rss, atom, json, cotidiano, economia, mundo, música, politica, saúde, tecnologia',
        'og:title': 'Conheça as opções de feed da Antena 1',
        'og:description': 'Fique por dentro de todas as notícias da Antena 1 através de feeds rss, atom ou json',
        'og:image': '',
    },
};

class Feeds extends Component {
    static fetchData(store) {
        return store.dispatch(getNewsCategoryIfNeeded());
    }

    render() {
        return (
            <div>
                <HeaderTags title={headerTags.title} meta={headerTags.meta} />
                <div className="pageWrapper tw-container tw-mx-auto tw-px-5">
                    <FeedsComponent />
                </div>
            </div>
        );
    }
}

export default Feeds;
